export default {
  common: {
    actions: "การดำเนินการ",
    view: "ดู",
    edit: "แก้ไข",
    delete: "ลบ",
    manage: "จัดการ",
    preview: "ดูตัวอย่าง",
    clear: "ล้าง",
    confirm: "ยืนยัน",
    submit: "ส่ง",
    next: "ถัดไป",
    back: "ย้อนกลับ",
    save: "บันทึก",
    reset: "รีเซ็ต",
    cancel: "ยกเลิก",
    find: "ค้นหา",
    refresh: "รีเฟรช",
    resend_email: "ส่งอีเมลอีกครั้ง",
    upload: "อัปโหลด",
    add: "เพิ่ม",
    prompt: "แจ้งเตือน",
    ok: "ตกลง",
    continue: "ดำเนินการต่อ",
    update: "อัปเดต",
    apply: "นำไปใช้",
    previous: "ก่อนหน้า",
    type: "ประเภท",
    success: "สำเร็จ",
    fail: "ล้มเหลว",
    no_data: "ไม่มีข้อมูล",
    start_time: "เวลาเริ่มต้น",
    end_time: "เวลาสิ้นสุด",
    per_page: "จำนวนรายการต่อหน้า",
    start_date: "เวลาเริ่ม",
    end_date: "เวลาสิ้นสุด",
    yes: "ใช่",
    login: "ล็อกอิน",
    password: "รหัสผ่าน",
    email: "อีเมล",
    welcome: "ยินดีต้อนรับ",
    search: "ค้นหา",
    enter: "เข้า",
    pending: "รออยู่",
    created: "สร้างแล้ว",
    no_options: "ไม่มีตัวเลือก",
    in_query: "กำลังค้นหาอยู่",
    noresult: "ไม่พบผลลัพธ์",
    system_default: "ระบบปริยาย",
    personal_template: "ต้นแบบส่วนตัว",
    otaUpdata: "OTA เพิ่มเติม",
    is: "ใช่.",
    is_not: "ไม่",
    light_setting: "การควบคุมแสง",

    turn_off: "ปิด",
    Blue: "สีน้ำเงิน",
    Green: "สีเขียว",
    Red: "สีแดง",
    Yellow: "สีเหลือง",
    White: "สีขาว",
    Pink: "สีชมพู",
    Cyan: "สีฟ้า",

    advGroup: "กลุ่มการแพร่กระจายป้ายราคาสินค้า",
    device_deleted: "ลบอุปกรณ์แล้ว",
    device_advgroup: "กลุ่มกระจายเสียง",

    common_form_get_code_surplus: "ส่งใหม่หลังจากวินาที",
    common_form_get_code: "ส่งใหม่",
    new_password: "รหัสผ่านใหม่",
    confirm_password: "ยืนยันรหัสผ่าน",
    set_password: "ตั้งรหัสผ่าน",
    column_manager: "การจัดการคอลัมน์",
    common_mismatched: "รหัสผ่านไม่ตรงกัน",
    common_password_enter: "กรุณากรอกรหัสผ่าน",
    common_confirm_password_enter: "กรุณากรอกยืนยันรหัสผ่าน",
    account_remote_login: "มีการเข้าสู่ระบบบัญชีจากที่อื่น กรุณาเข้าสู่ระบบใหม่",

  },

  dictionary: {
    vertical: "แนวตั้ง", // Vertical -> แนวตั้ง
    horizontal: "แนวนอน", // Horizontal -> แนวนอน
    generaluse: "ใช้ทั่วไป", // General Use -> การใช้งานทั่วไป
    discount: "ส่วนลด", // Discount -> ส่วนลด
    byunit: "ตามหน่วย", // By Unit -> ตามหน่วย
    by_value: "ตามมูลค่า", // By Value -> ตามมูลค่า
    promotion: "โปรโมชั่นพิเศษ", // Special Promotion -> โปรโมชั่นพิเศษ
  },

  month: {
    january: "เดือนมกราคม",
    february: "กุมภาพันธ์",
    march: "มีนาคม",
    April: "เมษายน",
    May: "พฤษภาคม",
    June: "มิถุนายน",
    July: "กรกฎาคม",
    August: "สิงหาคม",
    September: "กันยายน",
    October: "เดือนตุลาคม",
    November: "พฤศจิกายน",
    December: "เดือนธันวาคม",
  },

  zoontime: {
    International: "(GMT-12:00) เส้นวันสากลตะวันตก",
    Coordinated: "(UTC-11) เวลาสากลเชิงประสาน-11",
    Hawaii: "(UTC-10)ฮาวาย",
    Alaska: "(UTC-9)อลาสก้า",
    California: "(UTC-8)วลาแปซิฟิก (อเมริกาและแคนาดา) เช่น แคลิฟอร์เนีย",
    Arizona: "(UTC-7)ลา ปาซ, เวลาเมาน์เทน (อเมริกาและแคนาดา), อริโซนา",
    America: "(UTC-6) ซัสแคตเชวัน, เวลาเซ็นทรัล, อเมริกากลาง",
    Eastern:
      "(UTC-5)โบโกตา, ลิมา, กีโต, ริโอ บลังโก, เวลาอีสเทิร์น, อินเดียนา (ภาคตะวันออก)",
    Caracas: "(UTC-4:30)การากัส",
    Atlantic: "(UTC-4)เวลาแอตแลนติก, คูยาบา, จอร์จทาวน์, ลา ปาซ, ซานติอาโก",
    Newfoundland: "(UTC-3:30 นิวฟาวด์แลนด์",
    Brasilia: "(UTC-3)บราซิเลีย, บัวโนสไอเรส, กรีนแลนด์, คาเอิน",
    International2: "(UTC-2)เส้นวันสากลตะวันตก-02",
    Azores: "(UTC-1)หมู่เกาะเคปเวิร์ด, หมู่เกาะอาซอร์",
    Edinburgh: "(UTC)ดับลิน, เอดินบะระ, ลิสบอน, ลอนดอน, เส้นวันสากลตะวันตก",
    Brussels: "(UTC+1) อัมสเตอร์ดัม, บรัสเซลส์, ซาราเยโว",
    Damascus:
      "(UTC+2) เบรุต, ดามัสกัส, ยุโรปตะวันออก, ไคโร, เอเธนส์, เยรูซาเลม",
    Kuwait: "(UTC+3) แบกแดด, คูเวต, มอสโก, เซนต์ปีเตอร์สเบิร์ก, กรุงไนโรบี",
    Tehran: "(UTC+3:30) เตหะราน",
    Yerevan: "(UTC+4)อาบูดาบี, เยเรวาน, บากู, พอร์ตหลุยส์, ซามารา",
    Kabul: "(UTC+4:30) คาบูล",
    Karachi: "(UTC+5)อัชคาบัต, อิสลามาบัด, การาจี",
    Calcutta: "(UTC+5:30) เจนไน, กัลกัตตา, มุมไบ, นิวเดลี",
    Kathmandu: "(UTC+5:45)กาฐมาณฑุ",
    Novosibirsk: "(UTC+6) อัสตานา, ดากา, นิวซีเบอเรีย",
    Yangon: "(UTC+6:30) ย่างกุ้ง",
    Jakarta: "(UTC+7)กรุงเทพฯ, เวียงจันทน์, จาการ์ตา",
    Beijing:
      "(UTC+08:00) ปักกิ่ง, ฉงชิ่ง, ฮ่องกง, อูรุมชี, กัวลาลัมเปอร์, สิงคโปร์",
    Yakutsk: "(UTC+9)โอซากา, โตเกียว, โซล, ยาคุตสค์",
    Adelaide: "(UTC+9:30) อเดเลด, ดาร์วิน",
    Canberra: "(UTC+10) บริสเบน, ฟลัดดีโวสต็อก, กวม, แคนเบอร์รา",
    Islands: "(UTC+11)  หมู่เกาะโซโลมอน, นิวแคลิโดเนีย",
    Oakland: "(UTC+12) อานาเดล, โอ๊คแลนด์, เวลลิงตัน, ฟิจิ",
    alofa: "(UTC+13) นูกูอาลอฟา, หมู่เกาะซามัว",
    Island: "(UTC+14)เกาะคริสต์มาส",
  },
};
